import React from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles} from "@material-ui/styles";

import yup from '../../utility/yup';
import FormInput from '../../components/form-input/FormInput';

export const menusSchema = {
  menus: yup.string().required().trim(),
};

const useStyle = makeStyles(() => createStyles({
  textArea: {
    height: '50vh !important',
    fontFamily: 'monospace',
    overflow: 'auto !important',
  },
}), {name: 'VideoMenus'});

const TabMenus = () => {
  const classes = useStyle();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <FormInput
          label="Menus"
          name="menus"
          type="textarea"
          classes={{input:classes.textArea}}
        />
      </Grid>
    </Grid>
  )

};

export default TabMenus;
